var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sync-failed-txns-page"}},[_c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }